type formInput = Record<string, string>;

const formInputs: formInput[] = [
  {
    nameInput: 'name',
    label: 'cases.delivery.contacts.name',
    icon: '/case/restocare/contact_name.svg',
  },
  {
    nameInput: 'email',
    label: 'cases.kmm.form.email',
    icon: '/case/restocare/contact_email_kmm.svg',
  },
  {
    nameInput: 'phone',
    icon: '/case/restocare/contact_phone.svg',
  },
  {
    nameInput: 'comment',
    label: 'cases.delivery.contacts.comment',
    icon: '/case/restocare/contact_comment.svg',
  },
];

export default formInputs;
